import React from 'react'
import PropTypes from 'prop-types'

import { HighlightedHtml, Text } from 'Components/UI'
import { Flex } from 'Components/UI/_Legacy'

import {
  Container,
  Description,
  HiderBottom,
  HiderTop,
  PathHolder,
  StepText,
  Wrapper,
} from './styles'

import { PathVertical, Point } from '../paths'

function DataBlock({ step, index, odd }) {
  return (
    <Container mt={[40, 40, 0]}>
      <Wrapper>
        <Point />

        <Flex
          display={['none', 'none', 'flex']}
          justifyContent="center"
          width={3}
        />
        {index === 0 && <HiderTop />}

        {index === 5 && <HiderBottom />}

        <StepText mb={[6, 6, 7, 7, 9]}>Step {index + 1}</StepText>

        <Text
          as="h3"
          bold
          fontSize={[20, 20, 32, 32, 40]}
          lineHeight={1.25}
          mb={[3, 3, 3, 5, 7]}
          ml={[4, 4, 7, 9, 12]}
        >
          {step.title}
        </Text>

        <Description ml={[4, 4, 7, 9, 12]}>
          <HighlightedHtml>{step.description}</HighlightedHtml>
        </Description>
      </Wrapper>
      <PathHolder>
        <PathVertical shift={!odd} />
      </PathHolder>
    </Container>
  )
}

DataBlock.defaultProps = {
  index: 0,
}

DataBlock.propTypes = {
  index: PropTypes.number,
  odd: PropTypes.bool.isRequired,
  step: PropTypes.object.isRequired,
}

export default DataBlock
